export const entityTypes = {
    UPDATE_ENTITIES: 'UPDATE_ENTITIES',
    CLEAR_ENTITIES: 'CLEAR_ENTITIES',
};


